import type { TourDefinition } from "../types";

/**
 * Tour for the product editor (/app/products/:id and /app/products/new).
 * Emphasises the three things that most affect render quality:
 * accurate details, correct dimensions, and multi-angle reference images.
 */
export const productEditorTour: TourDefinition = {
  id: "product-editor",
  label: "Product Editor",
  description: "Set up a product for great renders",
  routeMatch: /^\/app\/products\/(?!$)[^/]+\/?$/,
  path: "/app/products/new",
  estimatedSeconds: 75,
  steps: [
    {
      target: "body",
      placement: "center",
      title: "Set up your product",
      body: "The better the info here, the better the renders. Name, dimensions and reference images all feed directly into the AI prompt.",
    },
    {
      target: '[data-tour="product-editor.tabs"]',
      placement: "bottom",
      title: "Details & Images",
      body: "There are two tabs: Details (name, brand, dimensions, specs) and Images (reference photos). Fill both out for best results.",
      showIf: () => !!document.querySelector('[data-tour="product-editor.tabs"]'),
    },
    {
      target: '[data-tour="product-editor.type"]',
      placement: "top",
      title: "Pick a product type",
      body: "Different product types use different fields. Choose the one that best matches what you're photographing — you can't change this later without starting over.",
      showIf: () => !!document.querySelector('[data-tour="product-editor.type"]'),
    },
    {
      target: '[data-tour="product-editor.save"]',
      placement: "bottom-end",
      title: "Save as you go",
      body: "Changes aren't saved automatically. Hit Save whenever you finish editing a tab — the product needs to be saved once before you can upload images.",
    },
    {
      target: '[data-tour="product-editor.continue"]',
      placement: "bottom-end",
      title: "Ready to generate",
      body: "Once you're happy with the product, jump straight into Studio with it attached. Briefs (scene setups) are presets you pick there for this product.",
      showIf: () => !!document.querySelector('[data-tour="product-editor.continue"]'),
    },
  ],
};
